/** Own SVG: CPU between 4 large arrows (not a third-party asset). */
export function KandoCenterIcon({ size = 30 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden
      className="kando-center-icon"
    >
      {/* 4 large arrows */}
      <path
        d="M16 1.5v7.5M16 1.5l-3.4 3.4M16 1.5l3.4 3.4"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 30.5V23M16 30.5l-3.4-3.4M16 30.5l3.4-3.4"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 16H9M1.5 16l3.4-3.4M1.5 16l3.4 3.4"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5 16H23M30.5 16l-3.4-3.4M30.5 16l-3.4 3.4"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* CPU chip */}
      <rect x="11" y="11" width="10" height="10" rx="1.4" stroke="currentColor" strokeWidth="1.8" />
      <rect x="13.2" y="13.2" width="5.6" height="5.6" rx="0.6" fill="currentColor" opacity="0.9" />
      <path
        d="M13 11V9.2M16 11V9.2M19 11V9.2M13 21v1.8M16 21v1.8M19 21v1.8M11 13H9.2M11 16H9.2M11 19H9.2M21 13h1.8M21 16h1.8M21 19h1.8"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}
